import useLocalStorageState from './src/useLocalStorageState.js';
export default useLocalStorageState;
